import { cn } from '@/lib/utils';

/** 6sense's mark: the "6" of its wordmark
 * (6sense.com/wp-content/themes/6Sense-2025/assets/img/logos/logo.svg, paths
 * unchanged), since the whole wordmark is too wide for an Integrations tile.
 * Inline rather than an <img>, so its navy half follows the .dark class. */
export function SixSenseIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox='0.9 1.3 19.9 30.4'
      aria-hidden
      className={cn('shrink-0', className)}
    >
      <path
        d='M12.8748 11.8304C14.033 12.0796 15.1551 12.5356 16.1932 13.2166L12.7608 17.3631C10.9006 16.4998 8.6324 16.9558 7.25226 18.6217C5.87211 20.2876 5.8241 22.6345 6.98823 24.3369L3.55587 28.4835C0.201512 24.8233 -0.0205112 19.1203 3.23183 15.1987L14.741 1.2998L18.7675 4.72284L12.8808 11.8304H12.8748Z'
        fill='#13BBB2'
      />
      <path
        d='M18.4127 28.1129C15.1603 32.0345 9.57975 32.8127 5.44531 30.095L8.87767 25.9484C10.7379 26.8118 13.0121 26.3558 14.3863 24.6899C15.7664 23.024 15.8144 20.6771 14.6503 18.9747L18.0826 14.8281C21.437 18.4883 21.659 24.1913 18.4067 28.1129H18.4127Z'
        className='fill-[#192232] dark:fill-foreground'
      />
    </svg>
  );
}
